module.exports = __webpack_public_path__ + "img/mbway.21edda2.svg";